import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import speciality01 from '../../assets/img/specialities/specialities-01.png';
import speciality02 from '../../assets/img/specialities/specialities-02.png';
import speciality03 from '../../assets/img/specialities/specialities-03.png';
import speciality04 from '../../assets/img/specialities/specialities-04.png';
import speciality05 from '../../assets/img/specialities/specialities-05.png';


const SpecialitiesSlider = () => {
  const settings = {
    dots: true,
    autoplay: false,
    infinite: true,
    variableWidth: true,
    arrows: false,
  };


  return (
    <section className="section section-specialities">
      <div className="container-fluid">
        <div className="section-header text-center">
          <h2>Hospital and Specialities</h2>
          <p className="sub-title">
            Explore our advanced Hospital and specialized care at Hitkari Hospital, where innovation and expertise redefine your healthcare experience.
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-9">
            <Slider {...settings} className="specialities-slider">
              
                <div  className="speicality-item text-center">
                  <a href="appointments.html">
                    <div className="speicality-img">
                      <img src={speciality01} className="img-fluid" alt="Urology" />
                      <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                    </div>
                  </a>
                  <p>Urology</p>
                </div>
                <div  className="speicality-item text-center">
                  <a href="appointments.html">
                    <div className="speicality-img">
                      <img src={speciality02} className="img-fluid" alt="Neurology" />
                      <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                    </div>
                  </a>
                  <p>Neurology</p>
                </div>
                <div  className="speicality-item text-center">
                  <a href="appointments.html">
                    <div className="speicality-img">
                      <img src={speciality03} className="img-fluid" alt="Orthopedic" />
                      <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                    </div>
                  </a>
                  <p>Orthopedic</p>
                </div>
                <div  className="speicality-item text-center">
                  <a href="appointments.html">
                    <div className="speicality-img">
                      <img src={speciality04} className="img-fluid" alt="Cardiology" />
                      <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                    </div>
                  </a>
                  <p>Cardiology</p>
                </div>
                <div  className="speicality-item text-center">
                  <a href="appointments.html">
                    <div className="speicality-img">
                      <img src={speciality05} className="img-fluid" alt="Dental" />
                      <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                    </div>
                  </a>
                  <p>Dental</p>
                </div>
            
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecialitiesSlider;




// import './Videos.css';
// import Navbar from '../Navbar/Navbar';
// import '../../assets/css/style.css';


// const Videos = () => {
   

//     return (
//         <div className="main-wrapper">
//             <header className="header">
//                 <Navbar />
//             </header>

			
// 			<div className="breadcrumb-bar">
// 				<div className="container-fluid">
// 					<div className="row align-items-center">
// 						<div className="col-md-12 col-12">
// 							<nav aria-label="breadcrumb" className="page-breadcrumb">
// 								<ol className="breadcrumb">
// 									<li className="breadcrumb-item"><a href="/">Home</a></li>
// 									<li className="breadcrumb-item active" aria-current="page">Video</li>
// 								</ol>
// 							</nav>
// 							<h2 className="breadcrumb-title">Video</h2>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
         
// 		<div className="content">
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//             <br />
//         </div>
//         </div>
//     );
// };

// export default Videos;